import { FaLightbulb, FaFirstdraft, FaAddressBook, FaPlus, FaMoneyBill } from 'react-icons/fa6';
import { FiThumbsUp, FiTruck } from 'react-icons/fi';

export const OpsMenu = () => [
     
     {
          key: "1.111",
          label: "New Quote",
          icon: <FaMoneyBill/>,
          link: "/quote",
     },
     {
          key: "1.9",
          label: "New Booking",
          icon: <FaPlus/>,
          link: "/bookings/new",
     },
     {
          key: "2",
          label: "Awaiting Acceptance",
          icon: <FaFirstdraft/>,
          link: "/bookings/Draft",
     },
     {
          key: "2.1",
          label: "Live Bookings",
          icon: <FaLightbulb/>,
          link: "/bookings/Live",
     },
     {
          key: "2.3",
          label: "Delivered",
          icon: <FiThumbsUp/>,
          link: "/bookings/Delivered",
     },
     {
          key: "2.4",
          label: "Address Book",
          icon: <FaAddressBook/>,
          link: "/addresses",
     }
]